var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasket2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7085 5.28187C16.5385 5.14408 16.2957 5.04567 16.0285 5.04567H13.6V4.69137C13.6 2.38841 11.2685 0.518482 8.54854 0.518482H8.45146C5.73143 0.518482 3.4 2.38841 3.4 4.69137V5.04567H0.971427C0.437146 5.04567 0 5.41966 0 5.87238V17.4462C0 17.8793 0.437146 18.2336 0.971427 18.2336H16.0285C16.5628 18.2336 17 17.8793 17 17.4462V5.85269C17 5.65586 16.9028 5.43934 16.7085 5.28187ZM5.34294 4.69007C5.34294 3.25319 6.80009 2.09186 8.45155 2.09186H8.54864C10.2001 2.09186 11.6572 3.25319 11.6572 4.69007V5.04438H5.34294V4.69007ZM1.94294 16.6575H15.0572V6.61897H13.6001V7.97715C13.6001 8.41015 13.1629 8.76446 12.6286 8.76446C12.0944 8.76446 11.6572 8.41015 11.6572 7.97715V6.61897H5.34294V7.97715C5.34294 8.41015 4.90579 8.76446 4.3715 8.76446C3.83722 8.76446 3.40008 8.41015 3.40008 7.97715V6.61897H1.94294V16.6575Z",
    fill: "#101728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket2);
export default __webpack_public_path__ + "static/media/basket2.80baf675bf1f60a46ad08a062aa247c3.svg";
export { ForwardRef as ReactComponent };